import { createSelector } from 'reselect';
import { includes, isNull } from 'lodash/fp';

import constants from '../../../../../../../../../../../ahm-constants';
import selectMembership from '../../../../../../../../../../../selectors/select-membership';

// @ts-expect-error - Automatic, Please fix when editing this file
const getCustomerBundle = (customer) => ({
  existingHealthFund: customer?.switching?.name,
  firstName: customer?.firstName,
  gender: customer?.gender,
  hasGivenConsent: customer?.switching?.transfer,
  isExistingHealthFundUnknown: customer?.switching?.name === constants.HEALTH_FUND.OTHER,
  isSwitching: !isNull(customer?.switching ?? null),
});

export default createSelector(selectMembership, (membership) => {
  const scale = membership?.scale;
  const client = membership?.members?.[0];
  const spouse = membership?.members?.[1];

  const bundle = {
    coverStartDate: membership?.starts,
    customers: {
      [constants.RELATIONSHIP.CLIENT]: getCustomerBundle(client),
    },
    scale,
  };

  if (includes(scale, [constants.SCALE.COUPLE, constants.SCALE.FAMILY])) {
    // @ts-expect-error [🤖 PLEASE FIX 🤖]: Element implicitly has an 'any' type because expression of type '"spouse"' can't be used to index type '{ client: { existingHealthFund: any; firstName: any; gender: any; hasGivenConsent: any; isExistingHealthFundUnknown: boolean; isSwitching: boolean; }; }'.
    bundle.customers[constants.RELATIONSHIP.SPOUSE] = getCustomerBundle(spouse);
  }

  return bundle;
});
